import React from "react";
import "./Navbar.css";
// import { Link, DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import { HashLink as Link } from "react-router-hash-link";

function Navbar() {
  return (
    <>
      <div className="navbar_outer">
        <div className="navbar">
          <Link
            id="navbar_home"
            className="navbar_link"
            style={{ color: "brown" }}
            to="/"
            smooth>
            <span>Home</span>
            <p>मुख्यपृष्ठ</p>
          </Link>
          <Link
            id="navbar_home"
            className="navbar_link"
            style={{ color: "aquamarine" }}
            to="/skill"
            smooth>
            <span>Skill</span>
            <p>प्रतिभा</p>
          </Link>
          <Link
            id="navbar_home"
            className="navbar_link"
            style={{ color: "brown" }}
            to="/project"
            smooth>
            <span>Project</span>
            <p>परियोजना</p>
          </Link>
          <Link
            id="navbar_home"
            className="navbar_link"
            style={{ color: "aquamarine" }}
            to="/contact"
            smooth>
            <span>Contact</span>
            <p>संपर्क</p>
          </Link>
        </div>
        <div className="hr_comp">
          <hr style={{ marginLeft: "5%", backgroundColor: "brown" }} />
          <hr style={{ marginRight: "5%", backgroundColor: "aquamarine" }} />
        </div>
      </div>
    </>
  );
}

export default Navbar;
